














































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import ConfirmSection from '../organisms/inquiry/ConfirmSection.vue'
import ImagePreview from '../organisms/inquiry/ImagePreview.vue'
import {
  InquiryForm,
  InquirySection,
} from '../organisms/inquiry/model/InquiryKind'

@Component({
  components: {
    'spa-confirm-section': ConfirmSection,
    'image-preview': ImagePreview,
  },
})
export default class InquiryConfirm extends Vue {
  @Prop({ required: true })
  form: InquiryForm

  @Prop({ default: false })
  isLoading: boolean

  @Prop({ required: true })
  sections: Map<string, InquirySection>

  @Prop()
  submit: () => void

  @Prop()
  back: () => void

  get orderedSections(): InquirySection[] {
    return Array.from(this.sections.values())
                .sort((a, b) => a.index - b.index)
  }

  previewKey(index: number): string {
    return `preview_${index}`
  }
}
